/* eslint-disable no-restricted-syntax */
export const findNodeById = (nodes, id) => {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};

export const updateNodeById = (nodes, id, updater) => nodes.map((node) => {
  if (node.id === id) {
    return updater(node);
  }
  return {
    ...node,
    children: node.children ? updateNodeById(node.children, id, updater) : [],
  };
});

export const deleteNodeById = (nodes, id) => nodes
  .filter((node) => node.id !== id)
  .map((node) => ({
    ...node,
    children: node.children ? deleteNodeById(node.children, id) : [],
  }));

export const insertChildNode = (nodes, targetId, newNode) => nodes.map((node) => {
  if (node.id === targetId) {
    return {
      ...node,
      children: [...(node.children || []), newNode],
    };
  }
  return {
    ...node,
    children: node.children ? insertChildNode(node.children, targetId, newNode) : [],
  };
});

export const insertSiblingNode = (nodes, targetId, newNode) => {
  const recurse = (list) => list.map((node) => {
    if (node.children?.some((child) => child.id === targetId)) {
      return {
        ...node,
        children: [...node.children, newNode],
      };
    }
    return {
      ...node,
      children: node.children ? recurse(node.children) : [],
    };
  });

  const atRoot = nodes.find((n) => n.id === targetId);
  return atRoot ? [...nodes, newNode] : recurse(nodes);
};
